import { reactQueryPost } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type {
  MasqueradingEntityType,
  MasqueradingMode,
} from "@circle-react/types/Masquerading";

export const viewOnlyMasqueradeAs = ({
  entityId,
  entityType = "CommunityMember",
  mode = "view",
}: {
  entityId: string | number;
  entityType: MasqueradingEntityType;
  mode?: MasqueradingMode;
}) =>
  reactQueryPost(
    internalApi.masquerading.masquerades.create({
      entityId,
      entityType,
      mode,
    }),
    {
      method: "POST",
    },
  );
